"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";
import {
  Activity,
  ChevronDown,
  ChevronRight,
  LayoutDashboard,
  Landmark,
  Send,
  ShoppingCart,
  PieChart,
  Boxes,
  Receipt,
  TrendingUp,
  Package,
  Wallet,
  Percent,
  Calendar,
  Truck,
  Users,
  UserSearch,
  Clock,
  FolderOpen,
  BarChart3,
  Settings,
  Shield,
  Globe,
  Sparkles,
  Star,
  Car,
  ChefHat,
  SlidersHorizontal,
  Building2,
  Bot,
  CalendarPlus,
  PiggyBank,
  Umbrella,
  Smartphone,
  ShieldAlert,
  ShieldCheck,
  ClipboardList,
  PackageCheck,
  Shirt,
  BookOpen,
  BadgeCheck,
  Menu,
  X,
  Mail,
  Megaphone,
} from "lucide-react";
import ThemeToggle from "./theme-toggle";
import PesquisaGlobal from "./pesquisa-global";

type Item = { href: string; label: string; icon: typeof LayoutDashboard; area?: string } | { sub: string };
const groups: { label: string; items: Item[] }[] = [
  {
    label: "Geral",
    items: [
      { href: "/", label: "Início", icon: LayoutDashboard },
      { href: "/assistente", label: "Assistente", icon: Bot },
      { href: "/correspondencia", label: "Correspondência", icon: Mail, area: "correspondencia" },
      { href: "/marketing", label: "Marketing & Comunicação", icon: Megaphone, area: "marketing" },
      { href: "/manual", label: "Manual", icon: BookOpen },
    ],
  },
  {
    label: "Vendas",
    items: [
      { sub: "Central" },
      { href: "/central-vendas", label: "Central Vendas", icon: Receipt, area: "vendas" },
      { href: "/fechos", label: "Fechos de Caixa", icon: Landmark, area: "vendas" },
      { sub: "Dashboards" },
      { href: "/dashboard-vendas", label: "Dashboard Vendas", icon: BarChart3, area: "vendas" },
      { href: "/dashboard-fechos", label: "Dashboard Fechos", icon: PieChart, area: "vendas" },
      { sub: "Entidades" },
      { href: "/clientes", label: "Clientes", icon: Users, area: "vendas" },
    ],
  },
  {
    label: "Compras",
    items: [
      { href: "/central-compras", label: "Central Compras", icon: ShoppingCart, area: "compras" },
      { href: "/dashboard-compras", label: "Dashboard Compras", icon: PieChart, area: "compras" },
      { href: "/fornecedores", label: "Fornecedores", icon: Truck, area: "compras" },
      { href: "/compras", label: "Compras & Encomendas", icon: ShoppingCart, area: "compras" },
    ],
  },
  {
    label: "F&B",
    items: [
      { href: "/stock", label: "Stock", icon: Package, area: "armazem" },
      { href: "/receitas", label: "Receitas", icon: ChefHat, area: "fb" },
      { href: "/central-artigos", label: "Central Artigos", icon: Boxes, area: "fb" },
      { href: "/config-stock", label: "Config. automáticas", icon: SlidersHorizontal, area: "fb" },
      { href: "/estado-sistema", label: "Estado do Sistema", icon: Activity, area: "gestao" },
    ],
  },
  {
    label: "Financeiro",
    items: [
      { href: "/bancos", label: "Bancos", icon: Landmark, area: "bancos" },
      { href: "/pagamentos", label: "Pagamentos", icon: Send, area: "financeiro" },
      { href: "/a-confirmar", label: "A confirmar (pagos na hora)", icon: BadgeCheck, area: "financeiro" },
      { href: "/imobiliario", label: "Património", icon: Building2, area: "imobiliario" },
      { href: "/imobiliario/mercado", label: "Mercado & Oportunidades", icon: Globe, area: "mercado_imob" },
      { href: "/ativos", label: "Investimentos & Ativos", icon: Car, area: "ativos" },
      { href: "/investimentos-financeiros", label: "Investimentos Financeiros", icon: TrendingUp, area: "financas_invest" },
      { href: "/iva", label: "IVA", icon: Percent, area: "financeiro" },
      { href: "/calendario", label: "Calendário", icon: Calendar, area: "calendario" },
      { href: "/auditoria", label: "Auditoria Financeira", icon: ShieldAlert, area: "auditoria" },
      { href: "/auditoria-preventiva", label: "Auditoria Preventiva", icon: ShieldCheck, area: "financeiro" },
    ],
  },
  {
    label: "RH",
    items: [
      { href: "/colaboradores", label: "Colaboradores", icon: Users, area: "rh" },
      { href: "/fardamento", label: "Fardamento", icon: Shirt, area: "rh" },
      { href: "/central-recrutamento", label: "Central Recrutamento", icon: UserSearch, area: "recrutamento" },
      { href: "/recrutamento", label: "Recrutamento (funil)", icon: UserSearch, area: "recrutamento" },
      { sub: "Ponto" },
      { href: "/ponto", label: "Ponto", icon: Clock, area: "ponto" },
      { href: "/central-ponto", label: "Central Ponto", icon: Clock, area: "ponto" },
      { href: "/dashboard-ponto", label: "Dashboard Ponto", icon: BarChart3, area: "ponto" },
    ],
  },
  {
    label: "Turnos & Horários",
    items: [
      { sub: "Horários" },
      { href: "/planeamento-turnos", label: "Planeamento", icon: CalendarPlus, area: "planeamento" },
      { href: "/racios-hora", label: "Rácios (hora/dia)", icon: TrendingUp, area: "racios" },
      { href: "/ferias", label: "Mapa de Férias", icon: Umbrella, area: "planeamento" },
      { href: "/banco-horas", label: "Banco de Horas", icon: PiggyBank, area: "planeamento" },
      { href: "/horarios", label: "Horários", icon: Calendar, area: "planeamento" },
      { href: "/dashboard-horarios", label: "Dashboard Horários", icon: BarChart3, area: "planeamento" },
      { href: "/sugestao-turnos", label: "Sugestão Turnos", icon: Sparkles, area: "planeamento" },
      { sub: "Configuração" },
      { href: "/regras-horarios", label: "Regras", icon: Settings, area: "planeamento" },
      { href: "/disponibilidade", label: "Disponibilidade", icon: Clock, area: "planeamento" },
      { href: "/avaliacao", label: "Avaliação", icon: Star, area: "avaliacoes" },
      { href: "/avaliacoes-ciclos", label: "Avaliações (equipa)", icon: Star, area: "avaliacoes" },
      { href: "/cartoes-estacionamento", label: "Cartões estacionamento", icon: Car, area: "rh" },
      { href: "/mapa-nomes", label: "Mapa de Nomes", icon: Users, area: "rh" },
    ],
  },
  {
    label: "Armazém",
    items: [
      { href: "/armazem", label: "Entregas ao bar", icon: Truck, area: "armazem" },
      { href: "/receber-armazem", label: "Receber do armazém", icon: PackageCheck, area: "armazem" },
      { href: "/pedir-armazem", label: "Pedir ao armazém", icon: Package, area: "armazem" },
    ],
  },
  {
    label: "Gestão",
    items: [
      { href: "/acessos", label: "Acessos", icon: Smartphone, area: "gestao" },
      { href: "/aprovacoes", label: "Aprovações", icon: ShieldCheck, area: "aprovacoes" },
      { href: "/central-documentos", label: "Central de Documentos", icon: FolderOpen, area: "central_documentos" },
      { href: "/documentos", label: "Docs por Fornecedor", icon: FolderOpen, area: "documentos" },
      { href: "/documentos-empresa", label: "Docs da Empresa", icon: Building2, area: "documentos" },
      { href: "/registo-processamento", label: "Registo de Processamento", icon: ClipboardList, area: "gestao" },
      { href: "/analitico", label: "Analítico", icon: BarChart3, area: "gestao" },
      { href: "/sites", label: "Sites de trabalho", icon: Globe, area: "gestao" },
      { href: "/permissoes", label: "Permissões", icon: Shield, area: "gestao" },
      { href: "/definicoes", label: "Definições", icon: Settings, area: "gestao" },
    ],
  },
];

export default function Sidebar({ areas, nome }: { areas: string[]; nome: string }) {
  const pathname = usePathname();
  const tudo = areas.includes("*");
  // grupos com pelo menos um item permitido para este perfil
  const gruposVis = groups
    .map((g) => ({
      ...g,
      items: g.items.filter((it) => "sub" in it || tudo || (it.area != null && areas.includes(it.area))),
    }))
    .filter((g) => g.items.some((it) => !("sub" in it)));

  const isActive = (href: string) => (href === "/" ? pathname === "/" : pathname.startsWith(href));
  // grupo "aberto" por defeito = o que contém a página atual (+ Geral); o utilizador pode dobrar/abrir.
  const activeLabel = gruposVis.find((g) => g.items.some((it) => !("sub" in it) && isActive(it.href)))?.label;
  const [aberto, setAberto] = useState<Record<string, boolean>>({});
  const estaAberto = (label: string) => aberto[label] ?? (label === activeLabel || label === "Geral");
  const alternar = (label: string) => setAberto((o) => ({ ...o, [label]: !estaAberto(label) }));
  // menu recolhível no telemóvel (drawer). Fecha sozinho ao mudar de página.
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => { setMobileOpen(false); }, [pathname]);

  // logout = navegação directa para /api/logout (GET) — o servidor limpa o cookie e reencaminha
  // para /login. Sem fetch/corrida no cliente (era a causa de "abre o login mas não sai").

  return (
    <>
      {/* Barra superior — SÓ telemóvel: botão de menu (hambúrguer) */}
      <div className="fixed inset-x-0 top-0 z-30 flex h-12 items-center gap-2 border-b border-neutral-200 bg-white px-2 dark:border-neutral-800 dark:bg-neutral-900 md:hidden">
        <button onClick={() => setMobileOpen(true)} aria-label="Abrir menu" className="rounded-lg p-2 hover:bg-neutral-100 dark:hover:bg-neutral-800"><Menu size={22} /></button>
        <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-teal-600 text-xs font-semibold text-white">T</div>
        <span className="text-sm font-semibold">TRIBO OS</span>
      </div>

      {/* Fundo escurecido quando o menu está aberto (telemóvel) */}
      {mobileOpen && <div onClick={() => setMobileOpen(false)} className="fixed inset-0 z-40 bg-black/40 md:hidden" aria-hidden />}

      <aside className={`fixed top-0 left-0 z-50 flex h-screen w-60 shrink-0 flex-col border-r border-neutral-200 bg-white transition-transform dark:border-neutral-800 dark:bg-neutral-900 md:sticky md:z-auto md:translate-x-0 ${mobileOpen ? "translate-x-0" : "-translate-x-full"}`}>
      <div className="flex items-center gap-2 px-5 py-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal-600 text-sm font-semibold text-white">
          T
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold leading-tight">TRIBO OS</div>
          <div className="text-xs text-neutral-500">Tribo da Praia</div>
        </div>
        <button onClick={() => setMobileOpen(false)} aria-label="Fechar menu" className="rounded-lg p-1.5 hover:bg-neutral-100 dark:hover:bg-neutral-800 md:hidden"><X size={18} /></button>
      </div>

      <div className="px-3 pb-2">
        <PesquisaGlobal />
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-2">
        {gruposVis.map((group) => {
          const open = estaAberto(group.label);
          const temAtivo = group.items.some((it) => !("sub" in it) && isActive((it as { href: string }).href));
          return (
          <div key={group.label} className="mb-2">
            <button
              onClick={() => alternar(group.label)}
              className="flex w-full items-center justify-between rounded-lg px-3 py-1.5 text-[11px] font-medium uppercase tracking-wide text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800/60"
            >
              <span className="flex items-center gap-1.5">
                {group.label}
                {!open && temAtivo && <span className="h-1.5 w-1.5 rounded-full bg-teal-500" title="secção atual" />}
              </span>
              {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
            </button>
            {open && group.items.map((item, idx) => {
              if ("sub" in item) {
                return (
                  <div key={`sub-${idx}`} className="px-3 pb-0.5 pt-2 text-[10px] font-medium uppercase tracking-wider text-neutral-300 dark:text-neutral-600">
                    {item.sub}
                  </div>
                );
              }
              const Icon = item.icon;
              const href = item.href;
              const active = href === "/" ? pathname === "/" : pathname.startsWith(href);
              return (
                <Link
                  key={href}
                  href={href}
                  onClick={() => setMobileOpen(false)}
                  className={`mb-0.5 flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${
                    active
                      ? "bg-neutral-100 font-medium text-neutral-900 dark:bg-neutral-800 dark:text-white"
                      : "text-neutral-600 hover:bg-neutral-100 dark:text-neutral-400 dark:hover:bg-neutral-800/60"
                  }`}
                >
                  <Icon size={18} strokeWidth={1.75} />
                  {item.label}
                </Link>
              );
            })}
          </div>
          );
        })}
      </nav>

      <div className="border-t border-neutral-200 p-3 dark:border-neutral-800">
        <div className="mb-2 flex items-center justify-between px-1 text-xs text-neutral-500">
          <span className="truncate" title={nome}>👤 {nome}{tudo ? "" : " (gerente)"}</span>
          <a href="/api/logout" className="rounded px-2 py-1 hover:bg-neutral-100 hover:text-red-600 dark:hover:bg-neutral-800">sair</a>
        </div>
        <ThemeToggle />
      </div>
      </aside>
    </>
  );
}
